interface SEOSchemaProps {
  type: 'website' | 'article' | 'about';
  title?: string;
  description?: string;
  url?: string;
  articleData?: {
    headline: string;
    author: string;
    datePublished: string;
    dateModified: string;
    image: string;
  };
  breadcrumbs?: Array<{ name: string; url: string }>;
  faqs?: Array<{ question: string; answer: string }>;
}

export default function SEOSchema({ type, title, description, url, articleData, breadcrumbs, faqs }: SEOSchemaProps) {
  const siteUrl = 'http://fkyy11.com/';

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '韩漫屋',
    url: siteUrl,
    description: '韩漫屋致力于为中文读者提供最优质的韩国漫画在线阅读体验，汇聚海量免费韩漫资源。',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'hello@fkyy11.com',
      contactType: 'customer service',
    },
    sameAs: ['http://fkyy11.com/'],
  };

  const webSiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '韩漫屋',
    url: siteUrl,
    description: description || '在韩漫屋通过漫画网址浏览免费韩漫大全与好看韩国漫画，并支持韩漫在线阅读，营造温馨阅读空间。',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${siteUrl}/search?q={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  };

  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: title || '韩漫屋 - 免费韩漫大全',
    description: description || '在韩漫屋浏览免费韩漫大全与好看韩国漫画，支持韩漫在线阅读。',
    url: url || siteUrl,
    isPartOf: {
      '@type': 'WebSite',
      name: '韩漫屋',
      url: siteUrl,
    },
    inLanguage: 'zh-CN',
    about: {
      '@type': 'Thing',
      name: '韩国漫画',
      description: '在线免费韩漫阅读平台',
    },
  };

  const articleSchema = articleData ? {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: articleData.headline,
    author: {
      '@type': 'Person',
      name: articleData.author,
    },
    datePublished: articleData.datePublished,
    dateModified: articleData.dateModified,
    image: articleData.image,
    publisher: {
      '@type': 'Organization',
      name: '韩漫屋',
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': url || siteUrl,
    },
  } : null;

  const breadcrumbSchema = breadcrumbs ? {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbs.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  } : null;

  const faqSchema = faqs && faqs.length > 0 ? {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  } : null;

  const schemas = [orgSchema, webSiteSchema, webpageSchema];
  if (articleSchema) schemas.push(articleSchema);
  if (breadcrumbSchema) schemas.push(breadcrumbSchema);
  if (faqSchema) schemas.push(faqSchema);

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(schemas, null, 2),
      }}
    />
  );
}